export default "__VITE_ASSET__Dc1LeuEp__"